import React from 'react';
import PropTypes from 'prop-types';
import simplehub from 'simplehub';
import { connect } from 'react-redux';
import { UftiModal } from '@blazar-plugins/ufti/dist/es-module/components/UftiModal';

import isMobile from 'shared/util/mobile.js';
import setupAppNexus from './util/setupAppNexus.js';
import actions from './state/actions.js';
import { gtmActions } from './state/gtm.js';

import WhitelabelContext from 'shared/setup/WhitelabelContext.jsx';
import Broadcast from 'shared/broadcast/Broadcast.jsx';
import CmsPanel from 'shared/cms/CmsPanel.jsx';
import MobileBanner from './misc/MobileBanner.jsx';
import { DesktopBanner } from './misc/DesktopBanner.jsx';
import PopularDestinations from './misc/PopularDestinations.jsx';
import SearchForm from './search/SearchForm.jsx';
import SupplierListing from './misc/SupplierListing.jsx';
import TopBar from './misc/TopBar.jsx';
import SeoTitle from './seo/SeoTitle.jsx';

class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        this.mobile = isMobile();
        this.isLoggedIn = FINN?.travel?.isLoggedIn || false;
        this.broadcasts = FINN?.travel?.broadcast || [];
        this.seoDescription = FINN?.travel?.seoDescription || '';
        this.trackCmsClick = this.trackCmsClick.bind(this);

        // TODO Remove eventHub from appNexus..
        this.eventHub = simplehub.create();

        setupAppNexus(this.eventHub);
    }

    componentDidMount() {
        this.props.dispatch(actions.initSearchPage());
    }

    trackCmsClick(title, url, index) {
        this.props.dispatch(gtmActions.clickCms({ title, url, index }));
    }

    render() {
        return (
            <>
                {!this.mobile && <DesktopBanner whitelabel={this.context.whitelabel} />}
                <div className="pageholder no-focus-ring">
                    <Broadcast broadcasts={this.broadcasts} />
                    <TopBar isMobile={false} isLoggedIn={this.isLoggedIn} showNumberOfResults={false} />
                    <main role="main">
                        <SeoTitle />
                        <div className="panel panel--info panel--bleed u-mb32">
                            <SearchForm />
                        </div>
                        {this.mobile && <MobileBanner whitelabel={this.context.whitelabel} />}
                        <PopularDestinations />
                        {this.context.whitelabel === 'blocket' ? <CmsPanel trackCmsClick={this.trackCmsClick} /> : null}
                        <SupplierListing />
                    </main>
                    {!FINN?.travel?.enableSeo && (
                        <section className="panel">
                            <p className="u-text-center u-d1">{this.seoDescription}</p>
                        </section>
                    )}
                    {this.context.whitelabel === 'blocket' && <UftiModal />}
                </div>
            </>
        );
    }
}

SearchPage.contextType = WhitelabelContext;

SearchPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

export default connect()(SearchPage);
